import { __assign, __rest } from "tslib";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, forwardRef } from "react";
import { mmcArray } from "../../../utils/functions";
import { GridContainer } from "./styles";
export var Grid = forwardRef(function (_a, ref) {
    var elementsPerRow = _a.elementsPerRow, _b = _a.gap, gap = _b === void 0 ? "8px" : _b, children = _a.children, props = __rest(_a, ["elementsPerRow", "gap", "children"]);
    var colCount = mmcArray(elementsPerRow || [1]);
    var start = 0;
    return (_jsxs(GridContainer, __assign({ ref: ref, gap: gap, colCount: colCount }, props, { children: [elementsPerRow === null || elementsPerRow === void 0 ? void 0 : elementsPerRow.map(function (rowCount) {
                var elementsToReturn = children
                    .slice(start, start + rowCount)
                    .map(function (child) {
                    return cloneElement(child, {
                        style: __assign(__assign({}, child.props.style), { gridColumn: "span ".concat(colCount / rowCount) }),
                    });
                });
                start += rowCount;
                return elementsToReturn;
            }), children.slice(start).map(function (child) {
                return child;
            })] })));
});
//# sourceMappingURL=index.js.map